import React from 'react';

const ResetRequest = ({date = new Date(), onButtonClick}:{date: Date, onButtonClick:() => void}) => (
    <div className="locker-details-reset-req">
        <p>Request sent on 
            <span className="date-time-highlight"> {date.toLocaleDateString()} </span>
            at 
            <span className="date-time-highlight"> {date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} </span>
        </p>
        <button className="locker-details-button" onClick={onButtonClick}>Reset Locker</button>
    </div>
);

export default ResetRequest;
